'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Attachment = function Attachment(width, height) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  (0, _classCallCheck3.default)(this, Attachment);
  this.width = width;
  this.height = height;
  this.image = options.image || null;
  this.render = options.render || null;
  this.xOffset = options.xOffset || 0;
  this.yOffset = options.yOffset || 0;
};

Attachment.CODEPOINT = 0xfffc;
Attachment.CHARACTER = "\uFFFC";
exports.default = Attachment;